import { createFileRoute, redirect } from '@tanstack/react-router';

import { legacySettingsSearch, validateLegacyTeamSearch } from '@/pages/settings/settings-tabs';

/**
 * The standalone Knowledge browser is gone (Appendix A §9 cut list) — it is a
 * tab in Team settings now. Old `/knowledge` links (and `?team=`) redirect.
 */
export const Route = createFileRoute('/knowledge')({
  validateSearch: validateLegacyTeamSearch,
  beforeLoad: ({ search }) => {
    throw redirect({ to: '/settings', search: legacySettingsSearch('knowledge', search) });
  },
});
